<script lang="ts">
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";

  export let headerCopy: string | false = false;
  export let subHeaderCopy: string | false = false;
  export let headerMode: "big" | "small" = "big";
  export let isShowGiftPreview: boolean = false;

  const headerScreenProps = headerMode === "big"
    ? {
      mobile: TypographyType.Headline1Special,
      desktop: TypographyType.Headline1Special
    }
    : {
      mobile: TypographyType.Headline2Special,
      desktop: TypographyType.Headline2Special
    };
</script>

<div>
  <div class="heading text-center {!isShowGiftPreview && 'lg:text-left'}">
    {#if headerCopy}
      <div class={subHeaderCopy ? "mb-4" : ""}>
        <Typography
          {...headerScreenProps}
          --font-color=var(--header-font-color)>
          <h1>{@html headerCopy}</h1>
        </Typography>
      </div>
    {/if}
    {#if subHeaderCopy}
      <div>
        <Typography
          mobile={TypographyType.Body1Medium}
          desktop={TypographyType.Headline2}
          --font-color=var(--subheader-font-color)>
          <h2>{@html subHeaderCopy}</h2>
        </Typography>
      </div>
    {/if}
  </div>
</div>
